import { render, staticRenderFns } from "./DiscussionsDetails.vue?vue&type=template&id=aed11678&"
import script from "./DiscussionsDetails.vue?vue&type=script&lang=js&"
export * from "./DiscussionsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports